const isChatbotUserMessage = (message) => {
  return message.role === "user";
};
const isChatbotAssistantMessage = (message) => {
  return message.role === "assistant";
};
const isChatbotContextSwitchInfo = (message) => {
  return message.type === "context-switch-info";
};

export { isChatbotAssistantMessage, isChatbotContextSwitchInfo, isChatbotUserMessage };
//# sourceMappingURL=guardsChatbotMessage.js.map
